require('dotenv').config()
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import router from './router'
import store from './store'
import App from './App.vue'
import Notifications from 'vue-notification'
import VueMask from 'v-mask'
import VueGtag from 'vue-gtag'

import { Amplify, Auth, Hub } from 'aws-amplify'
import { SocketIOMixin } from '@/mixins/socketIO.mixin'

import awsconfig from './aws-exports'

import * as Sentry from '@sentry/vue'
import { SocketNotifyMixin } from '@/mixins/socketNotify.mixin'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
      }),
    ],
    // Tracing
    tracesSampleRate: 0.2, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      awsconfig.aws_appsync_graphqlEndpoint,
      process.env.VUE_APP_REST_API_BASE_URL,
      process.env.VUE_APP_REST_API_AZURE_BASE_URL,
    ].filter(Boolean),
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    trackComponents: true,
    attachProps: true,
  })

  // Initialize Hotjar utility function for conditional loading
  window.initializeHotjar = function (userId, userAttributes = {}) {
    ;(function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          ;(h.hj.q = h.hj.q || []).push(arguments)
        }
      h._hjSettings = { hjid: Number(process.env.VUE_APP_HOTJAR_ID), hjsv: 6 }
      a = o.getElementsByTagName('head')[0]
      r = o.createElement('script')
      r.async = 1
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
      r.onload = function () {
        if (userId && window.hj) {
          hj('identify', userId, userAttributes)
        }
      }
      a.appendChild(r)
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
  }
}

Vue.config.productionTip = false
Amplify.configure({ ...awsconfig })

Vue.config.ignoredElements = [/amplify-\w*/]

async function applyUserMixin() {
  try {
    await Auth.currentAuthenticatedUser()
    Vue.mixin(SocketIOMixin)
    Vue.mixin(SocketNotifyMixin)
  } catch (error) {
    console.log('User not logged in, no mixin applied.')
  }
}

applyUserMixin().finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app')
})

Vue.use(Notifications)
Vue.use(VueMask)

Vue.use(
  VueGtag,
  {
    config: { id: 'G-R2SVZFEJB4' },
    enabled: process.env.NODE_ENV === 'release',
  },
  router
)

Hub.listen('auth', async (data) => {
  const { payload } = data
  if (payload.event === 'signIn') {
    applyUserMixin()
  } else if (
    payload.event === 'signOut' &&
    router.currentRoute.name !== 'login'
  ) {
    location.reload()
  }
})
